module.exports = __webpack_public_path__ + "static/media/AboutthirdWitness.9bbacabd.webp";